import { MenuOption, MenuSelectOption } from '@equip.health/ui';

export type AttachmentType = {
  file?: File;
  attachmentExternalId: string;
  fileName: string;
  statusCode?: NoteAttachmentStatus | null;
};

export type PatientNoteFilterType = {
  creator: AutoCompleteOption[];
  creatorRole: MenuSelectOption[];
  noteType: MenuSelectOption[];
  sessionLink: MenuOption;
  documentName?: MenuOption;
  showMyNotes: boolean;
  showNotesWithAttachment: boolean;
  status: MenuSelectOption[];
  title: string;
};
export enum CreatedByType {
  PROVIDER = 'provider',
  PATIENT = 'patient',
  SUPPORT = 'support',
}
export type CreatedByUserType = {
  authIdWithoutPrefix?: string;
  chosenName?: string;
  externalId: string;
  firstName: string;
  lastName: string;
  providerType: string;
  type: CreatedByType;
  avatar?: AvatarDetails;
  displayFirstName?: string;
  displayLastName?: string;
  providerTypeAtNoteCreation?: string;
};

type PatientNote = {
  addendumContent?: string;
  appointmentExternalId: string;
  attachments: AttachmentType[];
  authoredByProviderExternalId: string;
  createdByUser: CreatedByUserType;
  // TODO delete groupClassEventExternalId from this type, this should not be present on a patient note
  groupClassEventExternalId?: string;
  isConfidential: boolean;
  lastModifiedDateTime?: string;
  lastModifiedProviderExternalId?: string;
  noteCommunicationMethod?: string;
  noteContent: string;
  noteExternalId: string;
  noteStatus: string;
  noteType?: string;
  patientExternalId: string;
  sessionSummary: string | null;
  signedAtDateTime: string;
  signedBy: CreatedByUserType;
  tags: string[];
  title: string;
  updatedByUser: CreatedByUserType;
  // This object is always present in the response. The empty object looks like:
  // {templateRevisionId: null, surveyJsId: null}
  noteTemplateRevision: {
    templateRevisionId: string | null;
    surveyJsId: string | null;
  };
  noteTemplateRevisionData?: Record<string, unknown>;
};

export type ActivityWiths = { activityWithName: string };

export type ActivityWithChange = {
  timestamp: string;
  from: string[];
  to: string[];
};

export type PatientNoteListItemType = PatientNote & {
  activityDateTime: string;
  activityWiths: ActivityWiths[];
  addenda: NoteAddendum[];
  groupSectionEventExternalId?: string;
};

type AddendumAuthor = {
  externalId: string;
  firstName: string;
  lastName: string;
  providerType: string;
  type: string;
};

export type NoteAddendum = {
  after: Record<string, any>;
  author: AddendumAuthor;
  before: Record<string, any>;
  content: string;
  createdAtDateTime: string;
  addedActivityWith?: string[];
  removedActivityWith?: string[];
  noteDocumentChangeHistory?: AddendumAttachmentChanges;
};

export type PatientNoteListResponseType = {
  data: PatientNoteListItemType[];
  pageNumber: number;
  pageSize: number;
  count: number;
};

export enum NoteStatus {
  DRAFT = 'draft',
  SIGNED = 'signed',
  VOID = 'void',
  DELETE = 'Delete',
}

export enum NoteCommunicationMethod {
  VIDEO = 'Video',
  OUTBOUND_PHONE = 'Outbound phone',
}

export const IMAGE_FILE_EXTENSIONS = [
  'bmp',
  'jpg',
  'jpeg',
  'gif',
  'png',
  'tiff',
  'tif',
  'avif',
  'webp',
];

export const ACCEPTED_FILE_EXTENSIONS = [...IMAGE_FILE_EXTENSIONS, 'pdf'];

export enum NoteAttachmentStatus {
  UPLOADED = 'uploaded',
  NOT_YET_UPLOADED = 'sent upload url',
}
